export const destinations = [
  // {
  //   id: 1,
  //   name: "Santorini",
  //   country: "Greece",
  //   desc: "Where whitewashed cliffs meet the infinite Aegean blue",
  //   img: "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=1920&q=90&auto=format&fit=crop",
  // },
  // {
  //   id: 2,
  //   name: "Kyoto",
  //   country: "Japan",
  //   desc: "A thousand temples wrapped in eternal cherry blossom",
  //   img: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=1920&q=90&auto=format&fit=crop",
  // },
  // {
  //   id: 3,
  //   name: "Patagonia",
  //   country: "Argentina · Chile",
  //   desc: "Raw, untamed wilderness where the world ends in fire and ice",
  //   img: "https://images.unsplash.com/photo-1501854140801-50d01698950b?w=1920&q=90&auto=format&fit=crop",
  // },
  // {
  //   id: 4,
  //   name: "Maldives",
  //   country: "Indian Ocean",
  //   desc: "Crystalline lagoons suspended perfectly between sky and sea",
  //   img: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1920&q=90&auto=format&fit=crop",
  // },
  // {
  //   id: 5,
  //   name: "Machu Picchu",
  //   country: "Peru",
  //   desc: "The lost city of the Incas, forever cradled in sacred mist",
  //   img: "https://images.unsplash.com/photo-1526392060635-9d6019884377?w=1920&q=90&auto=format&fit=crop",
  // },
  // {
  //   id: 6,
  //   name: "Amalfi Coast",
  //   country: "Italy",
  //   desc: "Cliff-side villages cascading into the turquoise Tyrrhenian Sea",
  //   img: "https://images.unsplash.com/photo-1533587851505-d119e13fa0d7?w=1920&q=90&auto=format&fit=crop",
  // },

  {
    id: 8,
    "name": "Kerala",
    "country": "India",
    "desc": "Lush backwaters, swaying palms, and serene beaches in God's Own Country",
    "img": "https://ik.imagekit.io/nextdream/images/kerala.jpg"
  },
  {
    "id": 9,
    "name": "Himachal Pradesh",
    "country": "India",
    "desc": "Snow-capped peaks, pine forests, and peaceful mountain escapes",
    "img": "https://ik.imagekit.io/nextdream/images/himachal-pradesh.jpg"
  },
  {
    "id": 10,
    "name": "Rajasthan",
    "country": "India",
    "desc": "Royal palaces, golden deserts, and timeless tales of valor",
    "img": "https://ik.imagekit.io/nextdream/images/rajasthan.jpg"

  },
  {
    "id": 11,
    "name": "Uttarakhand",
    "country": "India",
    "desc": "Sacred rivers, Himalayan trails, and spiritual serenity",
    "img": "https://ik.imagekit.io/nextdream/images/uttarakhand.jpg"
  },
  {
    "id": 12,
    "name": "Meghalaya",
    "country": "India",
    "desc": "Living root bridges, misty hills, and endless waterfalls",
    "img": "https://ik.imagekit.io/nextdream/images/meghalaya.jpg"
  },
  {
    "id": 13,
    "name": "Assam",
    "country": "India",
    "desc": "Tea gardens, mighty Brahmaputra, and rich wildlife heritage",
    "img": "https://ik.imagekit.io/nextdream/images/assam.jpg"
  },
  {
    "id": 14,
    "name": "Andaman & Nicobar",
    "country": "India",
    "desc": "Turquoise waters, coral reefs, and untouched island beauty",
    "img": "https://ik.imagekit.io/nextdream/images/andaman.jpg"
  },
  {
    "id": 15,
    "name": "Lakshadweep",
    "country": "India",
    "desc": "Pristine lagoons, white sands, and secluded tropical paradise",
    "img": "https://ik.imagekit.io/nextdream/images/lakshadweep.jpg"
  }

];

// export const tours = [
//   // {
//   //   id: 1,
//   //   name: "Santorini & Cyclades",
//   //   region: "Greece · Europe",
//   //   type: "Guided group tour · Luxury",
//   //   badge: "Bestseller",
//   //   badgeGold: true,
//   //   days: 10,
//   //   price: "₹1,42,000",
//   //   img: "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=800&q=85&auto=format&fit=crop",
//   //   description: "Explore the iconic blue-domed churches of Oia, sail the caldera, and savour fresh seafood on sun-drenched terraces overlooking the Aegean.",
//   //   highlights: ["Oia sunset walk", "Caldera boat cruise", "Wine tasting at volcanic vineyards", "Akrotiri archaeological site"],
//   //   includes: ["5-star hotel", "Daily breakfast", "Expert guide", "Airport transfers"],
//   // },
//   // {
//   //   id: 2,
//   //   name: "Rajasthan Heritage Circuit",
//   //   region: "India · Heritage",
//   //   type: "Private tour · Cultural",
//   //   badge: "New",
//   //   badgeGold: false,
//   //   days: 7,
//   //   price: "₹58,000",
//   //   img: "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=800&q=85&auto=format&fit=crop",
//   //   description: "Journey through the golden cities of Jaipur, Jodhpur and Udaipur — a regal odyssey through palaces, forts and desert sunsets.",
//   //   highlights: ["Amber Fort sunrise", "Jaisalmer desert camp", "Lake Pichola boat ride", "Local cooking class"],
//   //   includes: ["Heritage hotel stays", "All meals", "Private car & driver", "Cultural experiences"],
//   // },
//   // {
//   //   id: 3,
//   //   name: "Maldives Lagoon Escape",
//   //   region: "Indian Ocean · Island",
//   //   type: "Private tour · Luxury",
//   //   badge: "Top Rated",
//   //   badgeGold: false,
//   //   days: 6,
//   //   price: "₹1,95,000",
//   //   img: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=85&auto=format&fit=crop",
//   //   description: "Disappear into an overwater villa above a crystal-clear lagoon — snorkel with manta rays, dine under the stars, and do absolutely nothing perfectly.",
//   //   highlights: ["Overwater villa stay", "Snorkelling with rays", "Sunset dolphin cruise", "Underwater dining"],
//   //   includes: ["Overwater bungalow", "All-inclusive meals", "Seaplane transfers", "Water sports"],
//   // },
//   // {
//   //   id: 4,
//   //   name: "Kyoto Cherry Blossom",
//   //   region: "Japan · Asia",
//   //   type: "Small group tour · Cultural",
//   //   badge: "Seasonal",
//   //   badgeGold: false,
//   //   days: 8,
//   //   price: "₹1,18,000",
//   //   img: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=800&q=85&auto=format&fit=crop",
//   //   description: "Walk through ancient bamboo groves, meditate in Zen gardens, and witness the ethereal beauty of sakura season in Japan's cultural heart.",
//   //   highlights: ["Arashiyama bamboo grove", "Fushimi Inari at dawn", "Tea ceremony", "Nishiki Market food tour"],
//   //   includes: ["Ryokan stay", "Breakfast & select dinners", "JR Pass", "Cultural experiences"],
//   // },
//   // {
//   //   id: 5,
//   //   name: "Amalfi Coast Drive",
//   //   region: "Italy · Europe",
//   //   type: "Private tour · Romantic",
//   //   badge: "Popular",
//   //   badgeGold: false,
//   //   days: 7,
//   //   price: "₹1,28,000",
//   //   img: "https://images.unsplash.com/photo-1533587851505-d119e13fa0d7?w=800&q=85&auto=format&fit=crop",
//   //   description: "Wind along one of the world's most dramatic coastlines — lemon groves, pastel fishing villages and Positano's cascade of colour.",
//   //   highlights: ["Positano village walk", "Ravello cliff gardens", "Boat to Capri", "Limoncello distillery"],
//   //   includes: ["Boutique hotel", "Daily breakfast", "Private driver", "Boat excursions"],
//   // },
//   // {
//   //   id: 6,
//   //   name: "Patagonia Wilderness Trek",
//   //   region: "Argentina · Chile",
//   //   type: "Adventure group tour",
//   //   badge: "Adventure",
//   //   badgeGold: false,
//   //   days: 12,
//   //   price: "₹2,15,000",
//   //   img: "https://images.unsplash.com/photo-1501854140801-50d01698950b?w=800&q=85&auto=format&fit=crop",
//   //   description: "Trek the W Circuit in Torres del Paine, witness the Perito Moreno glacier calving, and sleep under a Milky Way unpolluted by city light.",
//   //   highlights: ["Torres del Paine W trek", "Perito Moreno glacier walk", "Puerto Natales boat", "Condor spotting"],
//   //   includes: ["Eco lodge stays", "All meals on trek", "Expert guide", "Park fees"],
//   // },
//   {
//     id: 7,
//     name: "Phuket & Krabi Escape",
//     region: "International",
//     type: "Guided group tour · Beach & Adventure",
//     badge: "Trending",
//     badgeGold: false,
//     days: 7,
//     price: "₹68,000",
//     img: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&q=85&auto=format&fit=crop",
//     description: "Discover Thailand’s tropical charm with island hopping, turquoise waters, and vibrant nightlife across Phuket and Krabi.",
//     highlights: ["Phi Phi island tour", "James Bond Island", "Krabi 4-island trip", "Patong nightlife"],
//     includes: ["4-star hotel", "Daily breakfast", "Island tours", "Airport transfers"],
//   },
//   {
//     id: 8,
//     name: "Bali Island Retreat",
//     region: "International",
//     type: "Private tour · Honeymoon & Leisure",
//     badge: "Hot Deal",
//     badgeGold: true,
//     days: 6,
//     price: "₹72,000",
//     img: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=800&q=85&auto=format&fit=crop",
//     description: "Experience Bali’s serene temples, lush rice terraces, and luxury beach resorts with a perfect mix of relaxation and culture.",
//     highlights: ["Ubud rice terraces", "Tanah Lot temple", "Kintamani volcano view", "Beach club experience"],
//     includes: ["Private villa stay", "Daily breakfast", "Private cab", "Airport transfers"],
//   },
//   {
//     id: 9,
//     name: "Singapore City Experience",
//     region: "International",
//     type: "Family tour · City & Entertainment",
//     badge: "Family Favorite",
//     badgeGold: false,
//     days: 5,
//     price: "₹85,000",
//     img: "https://images.unsplash.com/photo-1508964942454-1a56651d54ac?w=800&q=85&auto=format&fit=crop",
//     description: "Explore futuristic architecture, world-class attractions, and vibrant city life in the heart of Southeast Asia.",
//     highlights: ["Marina Bay Sands SkyPark", "Sentosa Island", "Universal Studios", "Gardens by the Bay"],
//     includes: ["4-star hotel", "Daily breakfast", "City tour", "Attraction tickets"],
//   },
//   {
//     id: 10,
//     name: "Kuala Lumpur & Langkawi",
//     region: "International",
//     type: "Guided tour · City & Beach",
//     badge: "Value Pack",
//     badgeGold: false,
//     days: 6,
//     price: "₹65,000",
//     img: "https://images.unsplash.com/photo-1526481280690-7a2b3f5d7f7c?w=800&q=85&auto=format&fit=crop",
//     description: "Blend city vibes with tropical beaches as you explore Kuala Lumpur’s skyline and relax in Langkawi’s island paradise.",
//     highlights: ["Petronas Twin Towers", "Langkawi cable car", "Island hopping", "Night markets"],
//     includes: ["4-star hotel", "Daily breakfast", "Internal transfers", "Sightseeing tours"],
//   },
//   {
//     id: 11,
//     name: "Vietnam Discovery Tour",
//     region: "International",
//     type: "Guided group tour · Culture & Nature",
//     badge: "New",
//     badgeGold: true,
//     days: 8,
//     price: "₹78,000",
//     img: "https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=800&q=85&auto=format&fit=crop",
//     description: "Journey through Vietnam’s rich history, stunning landscapes, and vibrant cities from Hanoi to Ho Chi Minh.",
//     highlights: ["Ha Long Bay cruise", "Cu Chi tunnels", "Hoi An lantern town", "Mekong Delta tour"],
//     includes: ["4-star hotel", "Daily breakfast", "Guided tours", "Domestic flights"],
//   },
//   {
//     id: 12,
//     name: "Kerala Backwater Escape",
//     region: "Domestic",
//     type: "Private tour · Nature & Leisure",
//     badge: "Relaxation",
//     badgeGold: true,
//     days: 6,
//     price: "₹38,000",
//     img: "https://ik.imagekit.io/nextdream/images/kerala.jpg?tr=w-800,q-80,f-webp",
//     description: "Cruise through serene backwaters, unwind on palm-fringed beaches, and experience Kerala’s tranquil beauty.",
//     highlights: ["Alleppey houseboat stay", "Munnar tea gardens", "Kathakali cultural show", "Kovalam beach"],
//     includes: ["4-star hotel", "Daily breakfast", "Private cab", "Houseboat stay"],
//   },
//   {
//     id: 13,
//     name: "Himachal Mountain Retreat",
//     region: "Domestic",
//     type: "Guided tour · Hills & Adventure",
//     badge: "Popular",
//     badgeGold: false,
//     days: 7,
//     price: "₹32,000",
//     img: "https://ik.imagekit.io/nextdream/images/himachal-pradesh.jpg?tr=w-800,q-80,f-webp",
//     description: "Experience snow-capped mountains, scenic valleys, and charming hill towns in Himachal.",
//     highlights: ["Manali snow activities", "Shimla Mall Road", "Solang Valley", "Rohtang Pass"],
//     includes: ["3-star hotel", "Daily breakfast & dinner", "Local transfers", "Sightseeing tours"],
//   },
//   {
//     id: 14,
//     name: "Royal Rajasthan Journey",
//     region: "Domestic",
//     type: "Guided group tour · Heritage & Culture",
//     badge: "Bestseller",
//     badgeGold: true,
//     days: 8,
//     price: "₹42,000",
//     img: "https://ik.imagekit.io/nextdream/images/rajasthan.jpg?tr=w-800,q-80,f-webp",
//     description: "Step into royal history with grand forts, desert safaris, and vibrant culture across Rajasthan.",
//     highlights: ["Jaipur Amber Fort", "Jaisalmer desert safari", "Udaipur City Palace", "Pushkar ghats"],
//     includes: ["Heritage hotels", "Daily breakfast", "Camel safari", "Guided tours"],
//   },
//   {
//     id: 15,
//     name: "Uttarakhand Spiritual Escape",
//     region: "Domestic",
//     type: "Guided tour · Spiritual & Nature",
//     badge: "Peaceful",
//     badgeGold: false,
//     days: 6,
//     price: "₹28,000",
//     img: "https://ik.imagekit.io/nextdream/images/uttarakhand.jpg?tr=w-800,q-80,f-webp",
//     description: "Discover sacred rivers, Himalayan views, and peaceful retreats in Uttarakhand.",
//     highlights: ["Rishikesh Ganga Aarti", "Mussoorie hill views", "Haridwar temples", "River rafting"],
//     includes: ["3-star hotel", "Daily breakfast", "Local transport", "Guided visits"],
//   },
//   {
//     id: 16,
//     name: "Meghalaya Nature Explorer",
//     region: "Domestic",
//     type: "Guided tour · Nature & Adventure",
//     badge: "Offbeat",
//     badgeGold: true,
//     days: 7,
//     price: "₹36,000",
//     img: "https://ik.imagekit.io/nextdream/images/meghalaya.jpg?tr=w-800,q-80,f-webp",
//     description: "Explore misty hills, waterfalls, and unique living root bridges in Meghalaya.",
//     highlights: ["Cherrapunji waterfalls", "Living root bridges", "Shillong city", "Dawki river"],
//     includes: ["3-star hotel", "Daily breakfast", "Local guide", "All transfers"],
//   },
//   {
//     id: 17,
//     name: "Assam Wildlife & Tea Trails",
//     region: "Domestic",
//     type: "Guided tour · Wildlife & Culture",
//     badge: "Nature",
//     badgeGold: false,
//     days: 6,
//     price: "₹34,000",
//     img: "https://ik.imagekit.io/nextdream/images/assam.jpg?tr=w-800,q-80,f-webp",
//     description: "Experience lush tea gardens, rich culture, and wildlife safaris in Assam.",
//     highlights: ["Kaziranga safari", "Tea estate visit", "Brahmaputra river cruise", "Local culture"],
//     includes: ["3-star hotel", "Daily breakfast", "Safari rides", "Transfers"],
//   },
//   {
//     id: 18,
//     name: "Andaman Island Getaway",
//     region: "Domestic",
//     type: "Private tour · Beach & Leisure",
//     badge: "Top Rated",
//     badgeGold: true,
//     days: 6,
//     price: "₹52,000",
//     img: "https://ik.imagekit.io/nextdream/images/andaman.jpg?tr=w-800,q-80,f-webp",
//     description: "Relax on pristine beaches, explore coral reefs, and enjoy crystal-clear waters.",
//     highlights: ["Radhanagar Beach", "Scuba diving", "Cellular Jail show", "Island hopping"],
//     includes: ["Beach resort", "Daily breakfast", "Ferry transfers", "Water activities"],
//   },
//   {
//     id: 19,
//     name: "Lakshadweep Luxury Escape",
//     region: "Domestic",
//     type: "Premium tour · Beach & Luxury",
//     badge: "Exclusive",
//     badgeGold: true,
//     days: 5,
//     price: "₹65,000",
//     img: "https://ik.imagekit.io/nextdream/images/lakshadweep.jpg?tr=w-800,q-80,f-webp",
//     description: "Discover untouched lagoons, white sandy beaches, and a secluded island paradise.",
//     highlights: ["Agatti Island stay", "Snorkeling", "Lagoon exploration", "Sunset cruises"],
//     includes: ["Beach resort", "All meals", "Water sports", "Airport transfers"],
//   }
// ];
export const tours = [
  {
    id: 13,
    name: "Himachal Pradesh Custom Tour",
    region: "Domestic",
    type: "Customizable · Hills, Adventure & Leisure",
    badge: "Flexible",
    badgeGold: false,
    img: "https://ik.imagekit.io/nextdream/images/himachal-pradesh.jpg?tr=w-800,q-80,f-webp",
    description: "Explore the beauty of Himachal Pradesh with a fully customizable itinerary covering scenic hill stations, adventure spots, and peaceful retreats tailored to your preferences.",
    destinations: ["Shimla", "Manali", "Solang Valley", "Rohtang Pass", "Kasol", "Tosh", "Dharamshala", "McLeod Ganj", "Dalhousie", "Spiti Valley", "Kullu", "Chail"],
    highlights: ["Snow activities and adventure sports", "Colonial charm and shopping streets", "Mountain drives and scenic valleys", "Spiritual and cultural experiences", "Nature walks and offbeat villages"],
    includes: ["Hotel options (Budget to Luxury)", "Meals as per requirement", "Private/shared transportation", "Sightseeing as per selected itinerary", "Pickup & drop options"],
    customizableOptions: {
      duration: "Flexible (3–12 days or more)",
      budget: "Custom as per client requirement",
      hotelCategory: ["Budget", "3 Star", "4 Star", "Luxury"],
      transport: ["Private Cab", "Volvo Bus", "Self Drive"],
      activities: ["Paragliding", "River Rafting", "Skiing", "Camping", "Trekking"]
    }
  },

  {
    id: 7,
    name: "Thailand Custom Tour",
    region: "International",
    type: "Customizable · Beach, Adventure & Nightlife",
    badge: "Trending",
    img: "https://ik.imagekit.io/nextdream/images/thailand.jpg?tr=w-800,q-80,f-webp",
    description: "Discover Thailand’s tropical beauty with a customizable itinerary covering islands, beaches, nightlife, and cultural experiences.",
    destinations: ["Phuket", "Krabi", "Phi Phi Islands", "James Bond Island", "Patong", "Koh Samui", "Pattaya", "Bangkok"],
    highlights: ["Island hopping tours", "Vibrant nightlife", "Crystal-clear beaches", "Water sports adventures", "Thai street markets"],
    includes: ["Hotel options (Budget to Luxury)", "Meals as per plan", "Island tours", "Airport transfers", "Local transport"],
    customizableOptions: {
      duration: "Flexible (4–10 days)",
      budget: "Custom as per client requirement",
      hotelCategory: ["Budget", "3 Star", "4 Star", "Luxury Resort"],
      transport: ["Shared", "Private"],
      activities: ["Snorkeling", "Scuba diving", "Island hopping", "Nightlife tours", "Temple visits"]
    }
  },

  {
    id: 8,
    name: "Bali Custom Tour",
    region: "International",
    type: "Customizable · Honeymoon, Leisure & Culture",
    badge: "Hot Deal",
    badgeGold: true,
    img: "https://ik.imagekit.io/nextdream/images/bali.jpg?tr=w-800,q-80,f-webp",
    description: "Experience Bali’s perfect mix of luxury, culture, and scenic beauty with a personalized itinerary.",
    destinations: ["Ubud", "Kuta", "Seminyak", "Nusa Penida", "Uluwatu", "Tanah Lot", "Kintamani"],
    highlights: ["Rice terraces and temples", "Beach clubs and sunsets", "Volcano views", "Luxury villas", "Island tours"],
    includes: ["Villa/Hotel options", "Private transport", "Airport transfers", "Sightseeing tours"],
    customizableOptions: {
      duration: "Flexible (4–8 days)",
      budget: "Custom",
      hotelCategory: ["Villa", "4 Star", "Luxury Resort"],
      transport: ["Private"],
      activities: ["Temple tours", "Water sports", "Spa", "Island hopping", "Cultural shows"]
    }
  },

  {
    id: 9,
    name: "Singapore Custom Tour",
    region: "International",
    type: "Customizable · Family, City & Entertainment",
    badge: "Family Favorite",
    badgeGold: false,
    img: "https://ik.imagekit.io/nextdream/images/singapore.jpg?tr=w-800,q-80,f-webp",
    description: "Explore Singapore’s futuristic attractions, entertainment hubs, and family-friendly experiences with a flexible itinerary.",
    destinations: ["Singapore City", "Sentosa Island", "Marina Bay", "Orchard Road", "Clarke Quay"],
    highlights: ["Universal Studios", "SkyPark views", "Gardens by the Bay", "Night Safari", "Shopping streets"],
    includes: ["Hotel options", "Attraction tickets", "City tours", "Transport options"],
    customizableOptions: {
      duration: "Flexible (3–6 days)",
      budget: "Custom",
      hotelCategory: ["3 Star", "4 Star", "Luxury"],
      transport: ["Public", "Private"],
      activities: ["Theme parks", "City tours", "Shopping", "Night safari"]
    }
  },

  {
    id: 10,
    name: "Malaysia Custom Tour",
    region: "International",
    type: "Customizable · City & Beach",
    badge: "Value Pack",
    badgeGold: false,
    img: "https://ik.imagekit.io/nextdream/images/malaysia.jpg?tr=w-800,q-80,f-webp",
    description: "Experience Malaysia with a mix of vibrant city life and tropical island relaxation.",
    destinations: ["Kuala Lumpur", "Langkawi", "Genting Highlands", "Penang"],
    highlights: ["Petronas Towers", "Cable car rides", "Island hopping", "Night markets"],
    includes: ["Hotel options", "Transfers", "Sightseeing tours"],
    customizableOptions: {
      duration: "Flexible (4–8 days)",
      budget: "Custom",
      hotelCategory: ["3 Star", "4 Star", "Luxury"],
      transport: ["Private"],
      activities: ["City tours", "Beach activities", "Shopping"]
    }
  },

  {
    id: 11,
    name: "Vietnam Custom Tour",
    region: "International",
    type: "Customizable · Culture & Nature",
    badge: "New",
    badgeGold: true,
    img: "https://ik.imagekit.io/nextdream/images/vietnam.jpg?tr=w-800,q-80,f-webp",
    description: "Explore Vietnam’s rich culture and natural beauty with a customizable multi-city itinerary.",
    destinations: ["Hanoi", "Ha Long Bay", "Hoi An", "Da Nang", "Ho Chi Minh City", "Mekong Delta"],
    highlights: ["Ha Long Bay cruise", "Lantern streets", "Historic tunnels", "River delta tours"],
    includes: ["Hotel options", "Guided tours", "Domestic travel options"],
    customizableOptions: {
      duration: "Flexible (5–10 days)",
      budget: "Custom",
      hotelCategory: ["3 Star", "4 Star", "Luxury"],
      transport: ["Flights", "Private"],
      activities: ["Cruise", "City tours", "Cultural experiences"]
    }
  },

  {
    id: 12,
    name: "Kerala Custom Tour",
    region: "Domestic",
    type: "Customizable · Nature & Leisure",
    badge: "Relaxation",
    badgeGold: true,
    img: "https://ik.imagekit.io/nextdream/images/kerala.jpg?tr=w-800,q-80,f-webp",
    description: "Enjoy Kerala’s backwaters, hill stations, and beaches with a personalized travel experience.",
    destinations: ["Munnar", "Alleppey", "Kovalam", "Thekkady", "Wayanad", "Kochi"],
    highlights: ["Houseboat stay", "Tea gardens", "Beaches", "Wildlife sanctuary"],
    includes: ["Hotel options", "Houseboat stay", "Private cab", "Sightseeing"],
    customizableOptions: {
      duration: "Flexible (3–8 days)",
      budget: "Custom",
      hotelCategory: ["3 Star", "4 Star", "Luxury"],
      transport: ["Private Cab"],
      activities: ["Backwater cruise", "Ayurveda", "Sightseeing"]
    }
  },

  {
    id: 14,
    name: "Rajasthan Custom Tour",
    region: "Domestic",
    type: "Customizable · Heritage & Culture",
    badge: "Bestseller",
    badgeGold: true,
    img: "https://ik.imagekit.io/nextdream/images/rajasthan.jpg?tr=w-800,q-80,f-webp",
    description: "Experience Rajasthan’s royal heritage with forts, palaces, deserts, and vibrant culture.",
    destinations: ["Jaipur", "Udaipur", "Jaisalmer", "Jodhpur", "Pushkar", "Bikaner"],
    highlights: ["Forts & palaces", "Desert safari", "Cultural shows", "Lake views"],
    includes: ["Heritage hotels", "Transport", "Guided tours"],
    customizableOptions: {
      duration: "Flexible (4–10 days)",
      budget: "Custom",
      hotelCategory: ["Heritage", "4 Star", "Luxury"],
      transport: ["Private"],
      activities: ["Camel safari", "City tours", "Cultural events"]
    }
  },

  {
    id: 15,
    name: "Uttarakhand Custom Tour",
    region: "Domestic",
    type: "Customizable · Spiritual & Nature",
    badge: "Peaceful",
    badgeGold: false,
    img: "https://ik.imagekit.io/nextdream/images/uttarakhand.jpg?tr=w-800,q-80,f-webp",
    description: "Discover Uttarakhand’s spiritual sites and scenic hill stations with a flexible itinerary.",
    destinations: ["Rishikesh", "Haridwar", "Mussoorie", "Nainital", "Auli"],
    highlights: ["Ganga Aarti", "Hill views", "Adventure sports", "Temples"],
    includes: ["Hotel options", "Transport", "Sightseeing"],
    customizableOptions: {
      duration: "Flexible (3–7 days)",
      budget: "Custom",
      hotelCategory: ["3 Star", "4 Star"],
      transport: ["Private"],
      activities: ["Rafting", "Temple visits", "Skiing"]
    }
  },

  {
    id: 16,
    name: "Meghalaya Custom Tour",
    region: "Domestic",
    type: "Customizable · Nature & Adventure",
    badge: "Offbeat",
    badgeGold: true,
    img: "https://ik.imagekit.io/nextdream/images/meghalaya.jpg?tr=w-800,q-80,f-webp",
    description: "Explore Meghalaya’s waterfalls, caves, and unique landscapes with a flexible itinerary.",
    destinations: ["Shillong", "Cherrapunji", "Dawki", "Mawlynnong"],
    highlights: ["Waterfalls", "Living root bridges", "Crystal clear river", "Caves"],
    includes: ["Hotel options", "Guide", "Transfers"],
    customizableOptions: {
      duration: "Flexible (4–8 days)",
      budget: "Custom",
      hotelCategory: ["3 Star", "4 Star"],
      transport: ["Private"],
      activities: ["Trekking", "Caving", "Nature tours"]
    }
  },

  {
    id: 17,
    name: "Assam Custom Tour",
    region: "Domestic",
    type: "Customizable · Wildlife & Culture",
    badge: "Nature",
    badgeGold: false,
    img: "https://ik.imagekit.io/nextdream/images/assam.jpg?tr=w-800,q-80,f-webp",
    description: "Experience Assam’s wildlife, tea gardens, and cultural heritage.",
    destinations: ["Kaziranga", "Guwahati", "Majuli Island", "Jorhat"],
    highlights: ["Safari", "Tea gardens", "River island culture"],
    includes: ["Hotel options", "Safari rides", "Transfers"],
    customizableOptions: {
      duration: "Flexible (3–7 days)",
      budget: "Custom",
      hotelCategory: ["3 Star", "4 Star"],
      transport: ["Private"],
      activities: ["Safari", "Cultural tours"]
    }
  },

  {
    id: 18,
    name: "Andaman Custom Tour",
    region: "Domestic",
    type: "Customizable · Beach & Leisure",
    badge: "Top Rated",
    badgeGold: true,
    img: "https://ik.imagekit.io/nextdream/images/andaman.jpg?tr=w-800,q-80,f-webp",
    description: "Relax in Andaman with pristine beaches, water sports, and island hopping.",
    destinations: ["Port Blair", "Havelock", "Neil Island", "Ross Island"],
    highlights: ["Beaches", "Scuba diving", "Island hopping", "Light show"],
    includes: ["Resort options", "Ferry transfers", "Activities"],
    customizableOptions: {
      duration: "Flexible (4–8 days)",
      budget: "Custom",
      hotelCategory: ["3 Star", "4 Star", "Beach Resort"],
      transport: ["Ferry", "Private"],
      activities: ["Scuba", "Snorkeling", "Water sports"]
    }
  },

  {
    id: 19,
    name: "Lakshadweep Custom Tour",
    region: "Domestic",
    type: "Customizable · Beach & Luxury",
    badge: "Exclusive",
    badgeGold: true,
    img: "https://ik.imagekit.io/nextdream/images/lakshadweep.jpg?tr=w-800,q-80,f-webp",
    description: "Discover untouched islands, lagoons, and luxury experiences in Lakshadweep.",
    destinations: ["Agatti", "Bangaram", "Kadmat"],
    highlights: ["Lagoons", "Luxury stays", "Snorkeling", "Sunsets"],
    includes: ["Resort stay", "Meals", "Transfers", "Water sports"],
    customizableOptions: {
      duration: "Flexible (3–6 days)",
      budget: "Custom",
      hotelCategory: ["Luxury Resort"],
      transport: ["Flight + Boat"],
      activities: ["Snorkeling", "Water sports", "Island tours"]
    }
  }
]
export const testimonials = [
  { id: 1, name: "Priya Mehta", loc: "Mumbai, India", initials: "PM", quote: "The Rajasthan private tour was beyond anything we imagined. Every detail was handled with such care — we felt like absolute royalty the entire trip.", stars: 5 },
  { id: 2, name: "Arjun & Sneha Joshi", loc: "Pune, India", initials: "AS", quote: "We booked the Maldives escape on a whim and it became the best week of our lives. The team made everything completely seamless from start to finish.", stars: 5 },
  { id: 3, name: "Riya Kapoor", loc: "Delhi, India", initials: "RK", quote: "Santorini was a dream — our guide knew every hidden corner. Already booked our Kyoto tour for next spring through Next Dream Travel.", stars: 5 },
  { id: 4, name: "Vikram Nair", loc: "Bengaluru, India", initials: "VN", quote: "First international trip and I was nervous, but the 24/7 support gave us total confidence. Every single moment was perfectly orchestrated.", stars: 5 },
];

export const whyUs = [
  { icon: "clock", title: "Expert Local Guides", desc: "Every tour is led by passionate locals who bring destinations to life with authentic stories and hidden gems." },
  { icon: "edit", title: "Flexible Itineraries", desc: "Fully customisable tours tailored to your pace, preferences, and travel style — no cookie-cutter packages." },
  { icon: "star", title: "4.9 / 5 Avg. Rating", desc: "Verified five-star reviews from travellers across India and beyond." },
  { icon: "map", title: "24/7 On-Trip Support", desc: "Our dedicated support team is always a call away — wherever in the world your journey takes you." },
];
